import { useContent } from '../../../../hooks/use-server-content';

export interface TooltipProps {
    showTooltipAriaLabel: string;
    dismissTooltipAriaLabel: string;
}
export const useTooltipContent = (): TooltipProps | null => {
    const [content, getValueByName] = useContent('common', 'tooltip');
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.showTooltipAriaLabel) {
            contentFragment = null;
        }
    }
    return contentFragment as TooltipProps;
};
